import TransactionService from '@/api-services/transaction.service'
import Axios from 'axios'

export default {
  list_fqdns(config, searchTerm) {
    const ta = [
      {
        name: 'dns.fqdn.list',
        old: {
          value_regexp: `^${searchTerm}`,
          fetch_limit: 25
        }
      },
      {
        idx: 'record_list',
        name: 'dns.record.list',
        inner_join_ref: {
          fqdn_list: 'default'
        }
      },
      {
        idx: 'ip_subnet_list',
        name: 'nd.ip_subnet.list',
        inner_join_ref: {
          record_list: 'api_func_dns_record_rr_chain_target_contains_subnet'
        }
      },
      {
        idx: 'bcd_list',
        name: 'nd.bcd.list',
        inner_join_ref: {
          ip_subnet_list: 'api_fkey_nd_ip_subnet_bcd'
        }
      },
      {
        idx: 'vlan_list',
        name: 'nd.vlan.list',
        inner_join_ref: {
          bcd_list: 'default'
        }
      }
    ]
    return TransactionService.execute(config, ta)
  },
  list_fqdn_validation_information(config, fqdn_gpk) {
    const ta = [
      {
        name: 'dns.fqdn.list',
        old: {
          gpk_list: [fqdn_gpk]
        }
      },
      {
        idx: 'record_list',
        name: 'dns.record.list',
        inner_join_ref: {
          fqdn_list: 'default'
        }
      },
      {
        idx: 'ip_subnet_list',
        name: 'nd.ip_subnet.list',
        inner_join_ref: {
          record_list: 'api_func_dns_record_rr_chain_target_contains_subnet'
        }
      },
      {
        idx: 'bcd_list',
        name: 'nd.bcd.list',
        inner_join_ref: {
          ip_subnet_list: 'api_fkey_nd_ip_subnet_bcd'
        }
      },
      {
        idx: 'vlan_list',
        name: 'nd.vlan.list',
        inner_join_ref: {
          bcd_list: 'default'
        }
      }
    ]
    return TransactionService.execute(config, ta)
  },
  list_idm_synced_ous(config) {
    const ta = [
      {
        idx: 'ou_list',
        name: 'org.unit.list'
      }
    ]
    return TransactionService.execute(config, ta)
  },
  getOuHierarchy(config, gpk_list) {
    const ta = [
      {
        idx: 'ou_list',
        name: 'org.unit.list',
        old: {
          gpk_list: gpk_list
        }
      }
    ]
    return TransactionService.execute(config, ta)
  },
  validate_fqdn(config, fqdn) {
    const baseConfig = ('netdb_axios_config' in (config || {})) ? config.netdb_axios_config : config

    return Axios.post(
      '/api/vmware_vm_request/validate/fqdn',
      null,
      { ...baseConfig, params: { ...baseConfig?.params, fqdn } }
    )
  },
  validate_account_name(config, account_names) {
    const baseConfig = ('netdb_axios_config' in (config || {})) ? config.netdb_axios_config : config

    return Axios.post(
      '/api/vmware_vm_request/validate/account',
      {
        accounts: account_names
      },
      { ...baseConfig }
    )
  }
}
